"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTag = exports.StyledIcon = exports.TrainingAttribute = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Icon_1 = __importDefault(require("../icon/Icon"));
const tag_1 = __importDefault(require("../tag"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "trainingCard";
exports.classes = {
    body: `${PREFIX}-body`,
    subtitle: `${PREFIX}-subtitle`,
    footer: `${PREFIX}-footer`
};
exports.TrainingAttribute = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    color: theme.colours.slate,
    "&:first-of-type": {
        marginTop: "0"
    },
    "&:not(:first-of-type)": {
        marginTop: "18px"
    }
}));
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)({
    width: "24px",
    height: "24px",
    marginRight: "8px",
    fill: "currentColor"
});
exports.StyledTag = (0, styles_1.styled)(tag_1.default)({
    marginBottom: "16px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RyYWluaW5nLWNhcmQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5Qyx3REFBZ0M7QUFDaEMsaURBQXlCO0FBQ3pCLCtEQUF1QztBQUV2QyxNQUFNLE1BQU0sR0FBRyxjQUFjLENBQUM7QUFFakIsUUFBQSxPQUFPLEdBQUc7SUFDckIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0lBQ3RCLFFBQVEsRUFBRSxHQUFHLE1BQU0sV0FBVztJQUM5QixNQUFNLEVBQUUsR0FBRyxNQUFNLFNBQVM7Q0FDM0IsQ0FBQztBQUVXLFFBQUEsaUJBQWlCLEdBQUcsSUFBQSxlQUFNLEVBQUMsb0JBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNsRSxPQUFPLEVBQUUsTUFBTTtJQUNmLFVBQVUsRUFBRSxRQUFRO0lBQ3BCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDMUIsaUJBQWlCLEVBQUU7UUFDakIsU0FBUyxFQUFFLEdBQUc7S0FDZjtJQUNELHVCQUF1QixFQUFFO1FBQ3ZCLFNBQVMsRUFBRSxNQUFNO0tBQ2xCO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFVBQVUsR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFJLENBQUMsQ0FBQztJQUNyQyxLQUFLLEVBQUUsTUFBTTtJQUNiLE1BQU0sRUFBRSxNQUFNO0lBQ2QsV0FBVyxFQUFFLEtBQUs7SUFDbEIsSUFBSSxFQUFFLGNBQWM7Q0FDckIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxTQUFTLEdBQUcsSUFBQSxlQUFNLEVBQUMsYUFBRyxDQUFDLENBQUM7SUFDbkMsWUFBWSxFQUFFLE1BQU07Q0FDckIsQ0FBQyxDQUFDIn0=